<template>
  <div class="">
    <div class="" ref="any" tabindex="1"></div>
    <AppDataProperty
      contentId="stats"
      @dataAvailable="
        data => {
          stats = data?.metaData || {}
        }
      "
    />
    <AppDataProperty
      contentId="subscription"
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
    />
    <div class="sticky top-4 z-[1] px-6">
      <div class="flex w-full gap-4 items-center">
        <div class="grid grid-cols-3 justify-between w-full">
          <button
            class="buttonComponent font-bold px-4 py-5 flex justify-center items-center"
            v-for="(filter, i) in filters"
            :key="i"
            :class="{
              'rounded-l-xl rounded-none': i == 0,
              'rounded-none': i > 0 && i < filters.length - 1,
              'rounded-r-xl rounded-none': i == filters.length - 1,
              glassBg: filter.id !== activeFilter.id,
            }"
            @click="activeFilter = filter"
          >
            <div class="relative" v-if="filter.id == 'vip'" id="tab_vip">
              <div
                class="w-7 right-0 absolute translate-x-2/3 -translate-y-3/4"
              >
                <img
                  src="@/assets/images/king-recharge-assets/crown-white.svg"
                  class="w-full"
                  alt=""
                />
              </div>
              <div>
                {{ $t('coupons.filters.vip') }}
              </div>
            </div>
            <div v-else :id="'tab_' + filter.id">
              {{ $t('coupons.filters.' + filter.id) }}
            </div>
          </button>
        </div>
        <div class="">
          <button
            class="w-12 min-w-9 h-12 relative p-2"
            @click="filtersAreVisible = true"
            id="coupons-filter"
          >
            <img
              v-if="$ColorTheme.isLight()"
              src="@/assets/images/all/setting.svg"
              alt=""
            />
            <img v-else src="@/assets/images/all/setting-white.svg" alt="" />
          </button>
          <div
            class="fixed w-full h-full top-0 left-0"
            :class="{
              'pointer-events-none': !filtersAreVisible,
            }"
            @click="filtersAreVisible = false"
          ></div>
          <div
            class="grid grid-cols-4 gap-8 px-6 pt-5 absolute w-full left-0 opacity-0 -translate-y-4 duration-200"
            :class="{
              'opacity-100 translate-y-0': filtersAreVisible,
              'pointer-events-none': !filtersAreVisible,
            }"
          >
            <button
              class="buttonComponent px-0 py-5"
              :class="{
                glassBg: bookmaker.id !== selectedBookmaker.id,
              }"
              v-for="(bookmaker, i) in bookmakers"
              :key="i"
              @click="
                () => {
                  selectedBookmaker = bookmaker
                  filtersAreVisible = false
                }
              "
            >
              {{ $t('coupons.bookmakers.' + (bookmaker.id || 'all')) }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="activeFilter.id == 'validated'"
      class="dropShadowSm bg-white mt-12 mx-12 rounded-2xl"
    >
      <div class="py-1"></div>
      <div class="flex flex-col items-center">
        <div class="w-[40%]">
          <img src="@/assets/images/all/trophee.webp" alt="" class="w-full" />
        </div>
        <div
          class="buttonComponent !mb-0 bg-[#EA6595] bg-none relative font-bold !text-4xl !px-4 !py-2 rounded-full btn btn-anim small"
        >
          <div class="relative flex items-center gap-4">
            <div v-if="activeFilter.id == 'validated'">
              <AnimatedNumber number="45512" />
            </div>
            <div class="w-10 h-10">
              <img src="@/assets/images/all/check.png" alt="" />
            </div>
          </div>
        </div>
        <div class="py-2"></div>
        <div class="text-[#141922] font-bold text-2xl text-center px-2">
          {{ $t('coupons.validatedSection.title') }}
        </div>
        <div class="py-2"></div>
        <div class="px-8 text-center text-[#3C3C3C]">
          <div v-html="$t('coupons.validatedSection.description')"></div>
        </div>
        <div class="py-4"></div>
        <button
          class="buttonComponent !px-8 !py-4 text-lg rounded-full font-bold bg-none bg-[#3DAE34]"
          @click="showVipTab"
        >
          <span v-html="$t('coupons.validatedSection.subscribeButton')"></span>
        </button>
        <div class="py-4"></div>
      </div>
    </div>
    <div v-show="activeFilter.id == 'vip'" class="px-6 mt-12">
      <VipPresentation v-if="!isSubscribedToVip" />
      <div class="py-8"></div>
      <div
        class="rounded-[30px] bg-white p-4 pb-8 text-[#3C3C3C]"
        v-if="!isSubscribedToVip || !vipCouponsAllowed"
      >
        <div class="dropShadowXs">
          <div class="flex gap-4 items-center justify-between">
            <div class="flex gap-4 items-center">
              <div class="w-20 h-20 rounded-full p-2">
                <img
                  src="@/assets/images/all/fire.png"
                  alt=""
                  class="w-full h-full"
                />
              </div>
              <div>
                <div class="font-bold text-[#141922]">
                  {{ $t('coupons.vipSection.standard.alternativeOffer') }}
                </div>
                <div>
                  {{ $t('coupons.vipSection.standard.vipStandard') }}
                </div>
              </div>
            </div>
            <div class="w-20 h-20 rounded-full p-2">
              <img
                src="@/assets/images/all/fire.png"
                alt=""
                class="w-full h-full"
              />
            </div>
          </div>
          <div class="py-2"></div>
          <div class="px-2">
            <div class="py-2"></div>
            <div class="flex justify-between items-end">
              <div class="w-full">
                <div class="text-4xl inline-block relative text-center w-full">
                  <div class="font-bold" v-if="!vipCouponsAllowed">
                    {{
                      $t(
                        'coupons.vipSection.standard.additionalDepositToProgress',
                      )
                    }}
                  </div>
                  <div class="font-bold" v-else>
                    {{ $t('coupons.vipSection.standard.youAreVipStandard') }}
                  </div>
                </div>
                <div class="py-4"></div>

                <div>
                  <div
                    class="w-full flex items-center justify-center gap-0"
                    :style="{
                      '--progressPercent':
                        (vipProgressionPercentage || 5) + '%',
                    }"
                  >
                    <div class="w-[calc(100%-4ch)] ml-[2ch]">
                      <div class="w-full h-[15px] flex bg-white rounded-full">
                        <div
                          class="rounded-lg w-[calc(var(--progressPercent)-min(var(--progressPercent),0px))] bg-[#EDC106] h-full !min-w-[10px]"
                        ></div>
                        <div
                          class="w-[0] h-[0] rounded-full relative overflow-visible"
                        >
                          <img
                            src="@/assets/images/all/fire.png"
                            class="scale-[1.8] -translate-x-1/2 -translate-y-1/3 absolute w-[15px] h-[15px] object-contain !max-w-[1000px]"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="w-[4ch] text-right">
                      {{ Math.min(vipProgressionPercentage, 100) + '%' }}
                    </div>
                  </div>
                </div>
                <div class="py-4"></div>
                <div class="text-center text-lg" v-if="!vipCouponsAllowed">
                  {{ $t('coupons.vipSection.standard.youAreAt') }}
                  <span class="font-bold">
                    <span class="text-[#EDC106]">
                      {{ vipAmountDone }} FCFA
                    </span>
                    {{ $t('coupons.vipSection.standard.ofRequired') }}
                    <span class="text-[#EDC106]">
                      {{ vipAmountRequired }}
                    </span>
                  </span>
                </div>
                <div class="text-center text-lg" v-else>
                  <span class="font-bold">
                    <span class="text-[#EDC106]">
                      {{ $t('coupons.vipSection.standard.vipLevelReached') }}
                    </span>
                  </span>
                </div>
                <div class="py-4"></div>

                <div class="flex flex-col gap-2 text-lg items-center">
                  <div class="flex items-center gap-2">
                    <div class="w-5 h-5">
                      <img src="@/assets/images/all/check.svg" alt="" />
                    </div>
                    <div>
                      <span class="font-bold text-[#141922]"> 10+ </span>
                      <span>
                        {{ $t('coupons.vipSection.standard.winningCoupons') }}
                      </span>
                    </div>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="w-5 h-5">
                      <img src="@/assets/images/all/check.svg" alt="" />
                    </div>
                    <div>
                      <span class="font-bold text-[#141922]"> 1 Jour </span>
                      <span>
                        {{ $t('coupons.vipSection.standard.validity') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-2"></div>
            <div class="flex justify-center">
              <button
                class="buttonComponent small font-bold text-xl"
                @click="launchDeposit"
              >
                {{ $t('coupons.vipSection.standard.makeDeposit') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mx-auto w-4/5 py-6 -skew-y-1 origin-top-right"
      v-show="filteredCoupons[0]"
    >
      <div class="flex flex-col min-h-max gap-12 relative">
        <div
          v-for="(coupon, i) in filteredCoupons"
          class="w-full ripple p-4 rounded-3xl overflow-hidden bg-white min-h-[270px] flex items-center ticket"
          @click="showCoupon(coupon)"
          :key="i"
        >
          <img
            :src="coupon.pictureUrl"
            class="skew-y-1 origin-top-left"
            alt=""
            style="filter: drop-shadow(1px 3px 5px #0001)"
          />
          <div class="absolute w-full left-0">
            <div class="ticketRip">
              <div class="circleLeft !bg-[#242c3b]"></div>
              <div class="circleRight !bg-[#325693]"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-[250px] px-8 text-center gap-3 flex flex-col items-center justify-center"
      v-if="
        !filteredCoupons[0] && !(activeFilter.id == 'vip' && !vipCouponsAllowed)
      "
    >
      <div class="text-3xl font-bold title-color">
        {{ $t('coupons.couponNotFound.title') }}
      </div>
      <div>
        {{ $t('coupons.couponNotFound.description') }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '../utils/ModalComponent.vue'
import AppDataProperty from './AppDataProperty.vue'
import AnimatedNumber from '../utils/AnimatedNumber.vue'
import VipPresentation from './Coupons/VipPresentation.vue'

export default defineComponent({
  name: 'Coupons',
  components: {
    ModalComponent,
    AppDataProperty,
    AnimatedNumber,
    VipPresentation,
  },
  props: {},
  data() {
    return {
      stats: {},
      subscription: {},
      filtersAreVisible: false,
      activeFilter: { id: 'standard', name: 'Standard' },
      bookmakers: [
        {
          name: 'Tout',
          id: '',
        },
        {
          name: '1xBet',
          id: 'xbet',
        },
        {
          name: 'Betwinner',
          id: 'betwinner',
        },
        {
          name: 'Melbet',
          id: 'melbet',
        },
        {
          name: '888Starz',
          id: 'eightStarz',
        },
        {
          name: '1Win',
          id: '1win',
        },
      ],
      filters: [
        {
          name: 'Standard',
          id: 'standard',
        },
        {
          name: 'Validés',
          id: 'validated',
        },
        {
          name: 'Vip',
          id: 'vip',
        },
      ],
      displayVip: false,
      coupons: [{ shimmer: true }, { shimmer: true }],
      eventsIds: [],
      couponToShowDetail: {},
      appData: {},
      selectedBookmaker: { name: 'Tout', id: '' },
      vipNotAllowedCoupons: [
        {
          pictureUrl: '',
        },
        {
          pictureUrl: '',
        },
        {
          pictureUrl: '',
        },
        {
          pictureUrl: '',
        },
        {
          pictureUrl: '',
        },
      ],
    }
  },
  mounted() {
    this.loadCoupons()
    const id = this.$Events.handleEvent('app_data_updated', this.loadCoupons)
    this.eventsIds.push(id)
    this.$Events.dispatchEvent('coupons_update_required')
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async loadCoupons() {
      const coupons = await this.$Events.sendDataRequestResolve('coupons')
      this.coupons = coupons?.metaData?.coupons || this.coupons
    },
    showCoupon(coupon) {
      this.$Events.dispatchEvent('show_coupon_requested', coupon)
    },
    launchDeposit() {
      this.$Events.dispatchEvent('deposit_action_requested')
    },
    scrollAndPushTabsToTop() {
      document
        .querySelector('#couponsPageScrollableContainer')
        .scrollTo(0, document.body.offsetHeight / 4)
    },
    subscribeToVip() {
      this.$Events.dispatchEvent('vip_subscription_requested')
    },
    showVipTab() {
      const vipFilter = this.filters.find(filter => filter.id == 'vip')
      if (!vipFilter) {
        console.error('vipFilter not found')
        return
      }
      this.activeFilter = vipFilter
    },
  },
  computed: {
    vipCouponsAllowed() {
      return this.isSubscribedToVip || this.stats?.accessToDailyVip
    },
    requireVipAccess() {
      return this.displayVip && !this.vipCouponsAllowed
    },
    vipAmountDone() {
      return parseInt(this.stats?.todayBookmakerFunding || '0')
    },
    vipAmountRequired() {
      return parseInt(this.stats?.dailyVipMinAmount || '0')
    },
    vipProgressionPercentage() {
      return Math.floor((this.vipAmountDone * 100) / this.vipAmountRequired)
    },
    filteredCoupons() {
      let filteredCoupons = []
      if (this.activeFilter.id == 'standard') {
        filteredCoupons = this.coupons
          .filter(coupon => !coupon.isVip)
          .filter(coupon => !coupon.isValidated)
      } else if (this.activeFilter.id == 'vip' && this.vipCouponsAllowed) {
        filteredCoupons = this.coupons
          .filter(coupon => coupon.isVip)
          .filter(coupon => !coupon.isValidated)
      } else if (this.activeFilter.id == 'validated') {
        filteredCoupons = this.coupons.filter(coupon => !!coupon.isValidated)
      }
      if (this.selectedBookmaker.id) {
        filteredCoupons = filteredCoupons.filter(coupon => {
          return coupon.bookmaker == this.selectedBookmaker.id
        })
      }
      console.log(this.coupons,this.activeFilter.id, this.vipCouponsAllowed,filteredCoupons,this.selectedBookmaker.id)

      return filteredCoupons
    },
    isSubscribedToVip() {
      return this.subscription?.isActive
    },
    vipSubscriptionAmount() {
      return this.subscription?.amount
    },
  },
  watch: {
    activeFilter: {
      deep: true,
      handler() {
        this.$forceUpdate()
        setTimeout(() => {
          this.scrollAndPushTabsToTop()
        }, 500)
      },
    },
    // displayVip(newValue) {
    //   if (newValue !== true) return;
    //   this.$Events.dispatchEvent(
    //     "required_tour_guide",
    //     {
    //       el: "#vip-subscribe",
    //       title: "abonnez vous <br/> Pour avoirles coupons vip",
    //       // id: "vip-subscribe",
    //       position: "top-center",
    //     },
    //     1000
    //   );
    // },
  },
})
</script>
